<template>
  <v-container fluid class="ma-0 pa-0">
    <v-divider />
    <v-footer height="auto" class="savitarna-footer app--footer" color="white">
      <div v-html="content" />
    </v-footer>
  </v-container>
</template>
<script>
import headerData from './headerData'
import request from '@/utils/savitarnaMenu'

export default {
  name: 'SavFooter',
  mixins: [headerData],
  data() {
    return {
      content: null,
    }
  },

  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      if (!this.isLocal && this.$route.query.xid) {
        const xid = this.$route.query.xid
        request({
          url: `footer.do;jsessionid=${xid}`,
          method: 'get',
        }).then((res) => {
          this.content = this.parseFooter(res.data)
        })
      } else {
        if (this.isLocal || this.isDevelop) { 
          this.content = this.parseFooter(this.footerData)
        }
      }
    },
    parseFooter(data) {
      data = data.replace(/^.*?(?=<div id="footer-in">)/s, '')
      data = data.replace(/(?=<\/body>).*?$/s, '')
      return data
    },
  },
}
</script>
<style lang="scss">
.savitarna-footer {
  width: 999px;
  margin: 0 auto;
  padding: 0;
}
</style>
